// gatsby-browser.tsx AND gatsby-ssr.tsx
import React from 'react'
import Layout from './src/components/layout'
import { GatsbyBrowser, GatsbySSR } from 'gatsby'
import 'gatsby-plugin-breadcrumb/gatsby-plugin-breadcrumb.css'

// Import Google Fonts
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

// export const onRenderBody: GatsbySSR['onRenderBody'] = ({ setHeadComponents }) => {
//   setHeadComponents([
//     <script key="stripe-js" src="https://js.stripe.com/v3/" />
//   ])
// }
